// components/menu
// боковое меню

import Store    from 'Store';
import template from './template.jade';

var name = 'menu';
const store = new Store(name);

var links = [
  { name: 'bill-list',    text: 'Счета' },
  { name: 'cnt-list',     text: 'Контейнеры' },
  { name: 'advance-info', text: 'Баланс' },
  { name: 'zayavki-list',     text: 'Заявки' },
  { name: 'feedback',     text: 'Обратная связь' },
];
export default {

  name: name,
  template: template(),
  replace: false,

  data: () => ({
    name,
    store: store.data,
    links: links,
  }),
};



/** WEBPACK FOOTER **
 ** ./src/js/components/menu-right/index.js
 **/